import { supabase } from './supabase';
import { invokeEdge } from './invokeEdge';

export interface AmazonConnection {
  id?: number;
  user_id?: string;
  expires_at?: string;
  marketplace_id?: string;
  seller_id?: string;
  is_active?: boolean;
  created_at?: string;
  updated_at?: string;
}

class AmazonService {
  async startAuthorization(): Promise<string> {
    const { url } = await invokeEdge<{ url: string }>('amazon-oauth', {
      body: { action: 'start' },
    });
    if (!url) {
      throw new Error('Amazon did not return an authorization URL');
    }
    return url;
  }

  async completeAuthorization(code: string, state: string): Promise<void> {
    await invokeEdge('amazon-oauth', {
      body: { action: 'callback', code, state },
    });
  }

  async getConnections(): Promise<AmazonConnection[]> {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return [];

      const { data, error } = await supabase
        .from('amazon_connections')
        .select('id, user_id, expires_at, marketplace_id, seller_id, is_active, created_at, updated_at')
        .eq('user_id', user.id)
        .eq('is_active', true);

      if (error) throw error;
      return data || [];
    } catch (error) {
      console.error('Error getting connections:', error);
      throw error;
    }
  }

  async disconnect(): Promise<void> {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error('Not authenticated');

    const { error } = await supabase
      .from('amazon_connections')
      .update({ is_active: false, updated_at: new Date().toISOString() })
      .eq('user_id', user.id);

    if (error) throw error;
  }
}

export const amazonService = new AmazonService();
